// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"F_H","normalSpacing":"F_bC","default":"F_bD","uppercase":"F_bF","lowercase":"F_bG","capitalize":"F_bH"};